import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaModalOverlayRef } from '@global-front-components/ui/modal-overlay';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'apps/mnv-seguros-ng/src/environments/environment';

@Component({
	selector: 'app-modal-iframe-coberturas',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './modal-iframe-coberturas.component.html',
	styleUrls: ['./modal-iframe-coberturas.component.scss']
})
export class ModalIframeCoberturasComponent implements OnInit {
  @Input() data!: any;
  iframeSrc?: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    private _modalRef: CaModalOverlayRef<ModalIframeCoberturasComponent>
  ) {}

  async ngOnInit(): Promise<void> {
    await this.openIframe();
  }

  private async openIframe(): Promise<void> {
    const salud = environment.salud;

    const urlLogin = salud.urlLoginIntellij;
    const urlSelector = salud.urlSelectorIntellij;
    const empNumber = String(salud.urlIntellijEmpNumber);
    const empName = salud.urlIntellijEmpName;
    const secretKey = salud.urlIntellijSecretKey;

    const timestamp = Math.floor(Date.now() / 1000).toString();
    const frmRaw = empName + empNumber + timestamp + secretKey;
    const frmHex = (await this.sha256Hex(frmRaw)).toUpperCase();

    const loginUrl = `${urlLogin}?NUMEMP=${empNumber}&TIMESTAMP=${timestamp}&NOMUSUARIO=${empName}&FRM=${frmHex}`;

    try {
      await fetch(loginUrl, { method: 'GET', credentials: 'include', mode: 'no-cors' });
    } catch (err) {
      console.warn('fetch login falló, se continúa igual', err);
    }

    // Si hay categoría en data, la añade al selector
    let selectorFinal = urlSelector;
    const categoria = this.mapCategory(this.data?.codCategoriaSeleccionadaTraza);
    if (categoria) {
      const sep = selectorFinal.includes('?') ? '&' : '?';
      selectorFinal += `${sep}category=${categoria}`;
    }

    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(selectorFinal);
    console.log(this.iframeSrc);
  }

  private mapCategory(code?: string): string | null {
    if (!code) return null;
    const parts = code.split('-');
    if (parts.length === 1 && parts[0] === 'SIN') return 'Asistencia%20Ambulatoria';
    if (parts.length === 2) {
      if (parts[1] === 'SIN') return 'Asistencia%20Ambulatoria';
      if (parts[0] === 'CON' && parts[1] === 'LIBRE') return 'Reembolso';
      if (parts[0] === 'CON' && parts[1] === 'CONCERTADO') return 'Asistencia%20Sanitaria';
    }
    if (parts.length === 3) {
      if (parts[1] === 'CON' && parts[2] === 'LIBRE') return 'Reembolso';
      if (parts[1] === 'CON' && parts[2] === 'CONCERTADO') return 'Asistencia%20Sanitaria';
    }
    return null;
  }

  private async sha256Hex(message: string): Promise<string> {
    const data = new TextEncoder().encode(message);
    const hash = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hash))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('');
  }

  closeDialog(text?: string): void {
    if (text) this._modalRef.close(text);
    else this._modalRef.close();
  }
}
